import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import FullScreenErrorMessage from '../components/FullScreenErrorMessage'

export const PermissionDeniedNotice = () => {
  return (
    <FullScreenErrorMessage
      iconName={IconNames.LOCK}
      title="Sorry, you don't have permission to access this page."
      message="Request access from an admin and refresh the page"
    />
  )
}
